import { Select, styled } from '@mui/material';

const SmallSelect = styled(Select)(() => ({
  height: 31,
  width: 180,
  borderColor: '#252d55',
  '&.MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#252d55',
    },
    '&:hover fieldset': {
      borderColor: '#252d55',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#252d55',
    },
  },
}));

export default SmallSelect;
